// extracted by mini-css-extract-plugin
export var chip = "_nb-2";
export var chipBody = "_nb-8";
export var chipHeader = "_nb-9";
export var chipWithKind = "_nb-7";
export var icon = "_nb-3";
export var kind = "_nb-a";
export var remove = "_nb-5";
export var removeIcon = "_nb-6";
export var row = "_nb-0";
export var rowHistorical = "_nb-1";
export var text = "_nb-4";